var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3999 6.19998H7.80002V1.59996C7.80002 1.15835 7.44161 0.8 6.99995 0.8C6.55836 0.8 6.19998 1.15838 6.19998 1.59996V6.19998H1.59996C1.15838 6.19998 0.8 6.55836 0.8 6.99995C0.8 7.44161 1.15835 7.80002 1.59996 7.80002H6.19998V12.3999C6.19998 12.8416 6.55834 13.2 6.99995 13.2C7.44164 13.2 7.80002 12.8416 7.80002 12.3999V7.80002H12.3999C12.8416 7.80002 13.2 7.44164 13.2 6.99995C13.2 6.55834 12.8416 6.19998 12.3999 6.19998Z",
    fill: "#7F7D87",
    stroke: "#7F7D87",
    strokeWidth: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusUpload);
export default __webpack_public_path__ + "static/media/plus-upload.36461360b9406ad90260f8223e6f8c5c.svg";
export { ForwardRef as ReactComponent };